<script>
import { Input } from 'ant-design-vue'
export default {
  props: ['value', 'id', 'url', 'isTileLayer'],
  data() {
    return {
      lnglat: '',
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.map = new AMap.Map(this.$refs.map, {
      resizeEnable: true,
      zoom: 10,
      // center: [121.6216, 29.859515],
      center: [121.391632, 29.823287],
      viewMode: '3D',
    })
    if (this.url) {
      let layer = new AMap.ImageLayer({
        url: this.url,
        bounds: [
          // 121.57602694317671,29.0239,
          // 122.075,29.6431,
          // 121.571979,28.853303,
          // 122.279016,29.655454
          121.57601386424209, 28.850139780769453, 122.28311576241958, 29.652999034836032,
        ],

        //     url: '/maptile.png',
        // bounds: new AMap.Bounds([121.56, 29.7], [122.13, 28.99]),
        // zooms: [15, 20],
      })
      if (this.isTileLayer) {
        layer = new AMap.TileLayer({
          // 图块取图地址
          getTileUrl: this.url,
          zIndex: 999,
        })
      }

      console.log(layer,this.isTileLayer,"this.isTileLayerthis.isTileLayer")

      this.map.add(layer)
    }
    let that = this
    // eslint-disable-next-line no-undef
    this.clickListener = this.map.on('click', function (e) {
      that.addMarker(e.lnglat)
    })
    // eslint-disable-next-line no-undef
    let autoCompleteComponent = new AMap.Autocomplete({
      input: 'tipinput',
      // outPutDirAuto: true
    })
    // eslint-disable-next-line no-undef
    AMap.Event.addListener(autoCompleteComponent, 'select', (data) => {
      if (data.poi.location) {
        that.addMarker(data.poi.location)
      } else {
        this.$message.error('当前点位无法获取经纬度')
      }
    })
    if (this.id) {
      let lnlaObj = this.value.find((item) => item.id == this.id)
      if (lnlaObj) {
        this.map.setCenter([lnlaObj.lng, lnlaObj.lat])
      }
    }

    this.addTitle()
  },
  methods: {
    addTitle(newValue) {
      let marksValue = newValue ? newValue : this.value
      const markerList = marksValue.map(
        (item) =>
          // eslint-disable-next-line no-undef
          new AMap.Marker({
            position: [item.lng, item.lat],
            icon: item.icon || 'https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png',
          })
      )
      this.map.add(markerList)
    },
    addMarker(lnglat) {
      this.lnglat = {
        ...lnglat,
        id: this.id || Date.now(),
      }
      this.map.clearMap()
      if (this.id) {
        let index = this.value.findIndex((e) => e.id == this.id)
        let newValue = [...this.value]
        newValue.splice(index, 1)
        this.$nextTick(() => {
          this.addTitle(newValue)
        })
      } else {
        this.addTitle()
      }
      this.map.setCenter([lnglat.lng, lnglat.lat])
      let icon = new AMap.Icon({
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        imageSize: new AMap.Size(30, 40),
      })
      this.map.add(
        // eslint-disable-next-line no-undef
        new AMap.Marker({
          position: [lnglat.lng, lnglat.lat],
          icon,
        })
      )
    },
    getData() {
      return this.lnglat
    },
  },
  render() {
    return (
      <div class="mapview-main">
        <Input id="tipinput" enter-button="搜索" ref="input" placeholder="请输入要搜索地址" />
        <div ref="map" style={{ display: 'flex', height: '300px' }} />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.mapview-main {
  display: flex;
  flex-direction: column;
  & > div {
    margin-top: 20px;
  }
}
</style>
